

































































































import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { GetChannelInfo } from "@/services/channels/channelsService";
import { ChannelInfo } from "@/services/channels/types";
import { HavePermition, PermitionEnum } from "@/components/security/Permitions";

@Component
export default class ChannelInfoModal extends Vue {
    @Getter("getCurrentUser", { namespace: "authentication" }) getCurrentUser: any;
    channelInfo = {} as ChannelInfo;

    permitionEnum = PermitionEnum;
    havePermition = HavePermition;

    open(channelId: string) {
        GetChannelInfo(channelId).then(response => {
            this.channelInfo = response;
            this.$bvModal.show("modal-channelInfo");
        });
    }

    hide() {
        this.$bvModal.hide("modal-channelInfo");
    }

    goToBackground(id: string) {
        return {
            name: "updatebackground",
            params: { backgroundId: id }
        };
    }

    goToTemplate(id: string) {
        return {
            name: "updatetemplate",
            params: { templateId: id }
        };
    }

    goToSolution(id: string) {
        return {
            name: "updateSolution",
            params: { solutionId: id }
        };
    }

    goToChannelGroup(id: string) {
        return {
            name: "UpdateChannelGroup",
            params: {
                channelGroupId: id
            }
        };
    }

    goToStage(id: string) {
        return {
            name: "updateStage",
            params: {
                stageId: id
            }
        };
    }
}
